import RawData from 'src/replicant/data/LevelData.json';
import { LevelData } from 'src/replicant/data/LevelData.schema';
import { tuple } from 'src/replicant/utils/types';

const Data = RawData as LevelData;

function levelUpReward(fromLevel: number, toLevel: number) {
  let sum = 0;

  for (let i = fromLevel; i < toLevel; i++) {
    sum += Data[i + 1].reward_points;
  }
  return sum;
}

function requiredXp(currentLevel: number) {
  return Data[currentLevel + 1].xp;
}

function isMaxLevel(level: number) {
  return level >= Data.length - 1;
}

function milestoneXp(milestone: Milestone, petStage: MilestoneEvolution) {
  type MilestoneEvolutions = Record<MilestoneEvolution, number>;
  const milestoneXpTable: Record<Milestone, MilestoneEvolutions> = {
    evolution: {
      baby: 0,
      kid: 10,
      youth: 20,
      adult: 40,
    },
    death: {
      baby: 5,
      kid: 10,
      youth: 20,
      adult: 40,
    },
    debut: {
      baby: 80,
      kid: 80,
      youth: 80,
      adult: 80,
    },
  };

  return milestoneXpTable[milestone][petStage] ?? 0;
}

function toDisplay(level: number) {
  return Data[level].level;
}

function levelData(level: number) {
  return Data[level];
}

export const levelRuleset = {
  requiredXp,
  levelUpReward,
  milestoneXp,
  toDisplay,
  levelData,
  isMaxLevel,
};

export const milestoneEvolutions = tuple('baby', 'kid', 'youth', 'adult');
export type MilestoneEvolution = (typeof milestoneEvolutions)[number];
export const milestones = tuple('evolution', 'debut', 'death');
export type Milestone = (typeof milestones)[number];
